import { HomepageTileList } from '@app/data/contentful';
import { Box, Text } from '@redbubble/design-system';
import { UserInfo } from '@redbubble/next/types';
import { useUserInfo } from '@redbubble/next-provider';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Tile } from '../Tile/Tile';
import { BrandSignal } from './BrandSignal/BrandSignal';
import { brandSignalsData } from './brandSignalData';
import styles from './TileContainer.module.scss';

interface TileContainerProps {
  tiles: HomepageTileList;
}

interface TileProps {
  name?: string | null;
  callToActionText?: string | null;
  url?: string | null;
  desktopImage?: string | null;
  mobileImage?: string | null;
}

export const TileContainer: React.FC<TileContainerProps> = ({ tiles }) => {
  const [{ locale }] = useUserInfo<UserInfo>();
  const intl = useIntl();

  const tilesProps: TileProps[] | undefined = useMemo(
    () =>
      tiles?.itemsCollection?.items.map((item) => {
        return {
          name: item?.buttonText,
          callToActionText: item?.buttonText,
          url: item?.path,
          desktopImage: item?.desktopImage?.url,
          mobileImage: item?.mobileImage?.url,
        };
      }),
    [tiles]
  );

  return (
    <>
      <Text block element="h2" type="display2">
        <FormattedMessage defaultMessage="Shop Product Range" />
      </Text>
      <Box padding={0.75} />
      <Box className={styles.root}>
        {tilesProps && tilesProps.length > 0 && (
          <>
            {tilesProps.map((props: TileProps, index: number) => (
              <Tile
                key={props.name}
                locale={locale}
                index={index}
                name={props.name}
                callToActionText={props.callToActionText}
                url={props.url}
                desktopImage={props.desktopImage}
                mobileImage={props.mobileImage}
              />
            ))}

            <div className={styles.brandSignals}>
              {brandSignalsData.map((brandSignal, index) => (
                <BrandSignal
                  key={brandSignal.key}
                  title={intl.formatMessage(brandSignal.title)}
                  description={intl.formatMessage(brandSignal.text)}
                  imageUrl={brandSignal.imageUrl}
                  index={index}
                />
              ))}
            </div>
          </>
        )}
      </Box>
    </>
  );
};
